import { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode'; // Changed from jsonwebtoken to jwt-decode
import { checkEmailOnWaitlist } from '@/services/sendgrid';
import { SendgridStatus } from '@/utils/constants';

// Base URL with environment placeholder
const UPDATE_STATUS_BASE_URL = "https://australia-southeast1-lexi-458204.cloudfunctions.net/lexi-{env}-update-contact-status";

// Get environment from the current hostname
const getEnvironment = () => {
  const hostname = window.location.hostname;

  if (hostname.includes("staging.lexi.tips")) {
    return "dev";
  } else if (hostname.includes("lexi.tips") && !hostname.includes("staging")) {
    return "prod";
  }

  // Default to dev for localhost and any other domains
  return "dev";
};

// Get the URL with the correct environment
const getUpdateStatusUrl = () => UPDATE_STATUS_BASE_URL.replace("{env}", getEnvironment());

export const useCheckEmailAndUpdateStatus = (token) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyEmailAndUpdate = async () => {
      try {
        if (!token) {
          throw new Error('No token provided');
        }

        // Decode the JWT token
        let decodedEmail;
        try {
          const decoded = jwtDecode(token);
          decodedEmail = decoded.email;
        } catch (err) {
          throw new Error('Invalid or expired token');
        }

        // Check if email exists in SendGrid
        const checkResult = await checkEmailOnWaitlist(decodedEmail);
        
        if (!checkResult.isOnWaitlist) {
          throw new Error('Email not found in waitlist');
        }

        // Update contact status to active
        const response = await fetch(getUpdateStatusUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: decodedEmail,
            status: SendgridStatus.ACTIVE
          }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Failed to update status');
        }

        setIsSuccess(true);
      } catch (err) {
        setIsError(true);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    verifyEmailAndUpdate();
  }, [token]);

  return { isLoading, isError, isSuccess, error };
};